import React from "react";
import assets from "../../../shared/constants/assetVariables";
const csrdDataCollectionFeature = [
  {
    id: "1",
    icon: assets.icons.csrddc1,
    heading: "Comprehensive Data Collection",
    description:
      "Supports both quantitative and qualitative data, ensuring full compliance with ESRS disclosure requirements.",
  },
  {
    id: "2",
    icon: assets.icons.csrddc2,
    heading: "Smart Data Reuse",
    description:
      "Detects and utilizes previously tracked ESG data for CSRD reporting, eliminating redundant data entry.",
  },
  {
    id: "3",
    icon: assets.icons.dma4,
    heading: "AI-Assisted Structured Input",
    description:
      "Auto-populates qualitative disclosures using AI assistance, reducing manual effort while maintaining accuracy.",
  },
  {
    id: "4",
    icon: assets.icons.csrddc4,
    heading: "Collaborative Data Management",
    description: "Assigns data entry roles to different teams, ensuring a seamless workflow.",
  },
];
function Section_4() {
  return (
    <section className="csrd-landing-page-section-4-container">
      <div className="csrd-landing-page-section-4-header-container">
        <div
          className="csrd-landing-page-section-4-header"
          data-aos="fade-down"
          data-aos-delay="100"
          data-aos-once="true"
          data-aos-duration="700">
          <span className="text-1">CSRD</span> <span className="text-2">Data Collection</span>
        </div>
        <div
          className="csrd-landing-page-section-4-description"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true">
          Updapt’s structured data collection module enables organizations to efficiently track,
          manage, and validate CSRD disclosure data for material topics identified through the
          double materiality assessment.
        </div>
      </div>
      <div
        className="key-feature-heading"
        data-aos="zoom-in"
        data-aos-delay="100"
        data-aos-duration="700"
        data-aos-once="true">
        Key Features
      </div>
      <div className="key-feature-content-container">
        <div className="key-feature-inner-content-container">
          <div
            className="key-feature-right-container"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="700"
            data-aos-once="true">
            {csrdDataCollectionFeature?.map((ele) => {
              return (
                <div className="key-feature-card-container" key={ele?.id}>
                  <div className="dma-icon">
                    <img src={ele?.icon} alt="dm1-icon" />
                  </div>
                  <div className="feature-header-description-container">
                    <div className="feature-header">{ele?.heading}</div>
                    <div className="feature-description">{ele?.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className="key-feature-left-container"
            data-aos="zoom-in-left"
            data-aos-delay="100"
            data-aos-duration="700"
            data-aos-once="true">
            <div
              className="csrd-bg1-img-container"
              data-aos="zoom-in"
              data-aos-delay="100"
              data-aos-duration="700"
              data-aos-once="true">
              <img src={assets.images.csrddc_bg1} alt="csrddc-bg1" className="csrddc_bg1" />
            </div>
            <div className="csrd-bg2-img-container">
              <img src={assets.images.csrddc_img3} alt="csrddc-bg2" className="csrddc_bg2" />
            </div>
            <div className="csrddc-image-container">
              <div className="csrddc-imag1-container">
                <img
                  src={assets.images.csrddc_img1}
                  alt="csrddc-insight"
                  loading="lazy"
                  className="csrddc_insight"
                />
              </div>
            </div>
            <div className="csrddc-image-container">
              <div className="csrddc-imag2-container">
                <img
                  src={assets.images.csrddc_img2}
                  alt="csrddc-view"
                  loading="lazy"
                  className="csrddc_view"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section_4;
